module.exports = __webpack_public_path__ + "static/img/kongtiao-zhileng-active.430630a6.png";